import { JSX, JSXElement } from 'solid-js';
import { Button, ButtonProps } from '~/components/ui/Button';
import { twMerge } from 'tailwind-merge';

type BaseProps = {
  children: JSXElement;
  elementAttributes?: JSX.HTMLAttributes<any>;
  dataTestId?: string;
};
export default function Base(props: BaseProps): JSXElement {
  return (
    <Button
      {...(props.elementAttributes as ButtonProps)}
      variant={`ghost`}
      size={`sm`}
      class={twMerge(
        `font-normal px-1.5 text-fg-default hover:bg-bg-muted active:bg-bg-emphasized`,
        props.elementAttributes?.class ?? ''
      )}
      {...(props.dataTestId && { 'data-testid': props.dataTestId })}
    >
      {props.children}
    </Button>
  );
}
